/**
 * Generate a file by blob data
 * @param response backend returned blob
 * @param fileNameWithSuffix full file name
 */
export const saveAsFile = (response: Blob, fileNameWithSuffix: string) => {
  const url = window.URL.createObjectURL(response);
  const link = document.createElement('a');
  // same as: link.setAttribute('href', url);
  link.href = url;
  // same as: link.setAttribute('download', fileNameWithSuffix);
  link.download = fileNameWithSuffix;
  document.body.appendChild(link);
  link.click();
};
